import React from 'react';
import Locale from 'localization/Localization';
import { AppServices } from 'services/AppServices';
import { PushRedirect } from '../common/PushRedirect';
import { NavLink } from 'react-router-dom';
import Badge from 'react-bootstrap/Badge';
import { UserConsumer } from 'components/contexts/UserContext';

interface NavigationBarState {
    redirectPath: string | undefined;
    menuOpen: boolean;
    menuStyle: string;
    menuButtonStyle: string;
}

export class NavigationBar extends React.Component<{}, NavigationBarState>
{
    constructor(props: {}) {
        super(props);

        this.state = {
            redirectPath: undefined,
            menuOpen: false,
            menuStyle: 'main-nav-menu',
            menuButtonStyle: 'nav-menu-button'
        };

        this.onLogoutClicked = this.onLogoutClicked.bind(this);
        this.onMenuToggled = this.onMenuToggled.bind(this);
    }

    onLogoutClicked() {
        AppServices.loginService.logOut();
        this.setState({ redirectPath: '/' });
    }

    onMenuToggled(event: React.MouseEvent<HTMLElement>) {
        this.setState({
            menuOpen: !this.state.menuOpen,
            menuStyle: this.state.menuOpen ? 'main-nav-menu menu-closed' : 'main-nav-menu menu-open',
            menuButtonStyle: this.state.menuOpen ? 'nav-menu-button menu-button-close' : 'nav-menu-button menu-button-open'
        });
    }

    public render() {
        if (this.state.redirectPath !== undefined)
            return <PushRedirect to={this.state.redirectPath} />;


        const links = <>
            <NavLink to={'/home'}>{Locale.get('nav_homeLink')}</NavLink>
            <NavLink to={'/account'}>{Locale.get('nav_accountLink')}</NavLink>
            <NavLink to={'/programs'}>{Locale.get('nav_programsLink')}</NavLink>

            <UserConsumer>
                {
                    context => <>
                        {
                            context.org !== undefined &&
                            <NavLink to={'/content'}>{Locale.get('nav_contentLink')}<Badge variant='primary'>Pro</Badge></NavLink>
                        }
                    </>
                }
            </UserConsumer>

            <button className='logout-button' onClick={this.onLogoutClicked}>{Locale.get('nav_logOut')}</button>
        </>

        return <>
            <div className='navigation-bar'>
                <h2>{Locale.get('home_title')}</h2>
                <div className='main-nav'>{links}</div>
                {
                    this.state.menuOpen &&
                    <div className='mobile-overlay' onClick={this.onMenuToggled} />
                }
                <div className={this.state.menuStyle}>
                    <button className={this.state.menuButtonStyle} onClick={this.onMenuToggled} />
                    <div className='menu-content'>{links}</div>
                </div>
            </div>
        </>
    }
}